import { guardAdminNavigation } from './UnsavedChanges';
import React, { useEffect, useState } from 'react';
import { RoleViewContext } from './RoleViewContext';
import NotarioDashboard from './NotarioDashboard';
import LawyerWorkspace from './LawyerWorkspace';
import './RoleManagement.css';
const API = process.env.REACT_APP_API_URL || 'http://localhost:5001';
const labels = { abogado_wisby: 'Abogado de Wisby', notario: 'Notario titular', abogado_notaria: 'Abogado de Notaría' };
export default function StandaloneRoleScreen({ userId }) {
  const [account, setAccount] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    const headers = { 'x-auth-token': localStorage.getItem('token') || sessionStorage.getItem('token') };
    const load = async () => {
      const access = await fetch(`${API}/api/admin/stats`, { headers });
      if (!access.ok) throw new Error('Inicia sesión como administrador para acceder a esta pantalla.');
      const response = await fetch(`${API}/api/roles`, { headers });
      const data = await response.json();
      if (!response.ok) throw new Error(data.msg || 'No se pudo cargar la cuenta.');
      const selected = (data.users || []).find(u => u._id === userId && u.isActive !== false && labels[u.role]);
      if (!selected) throw new Error('La cuenta seleccionada no está disponible.');
      if (active) setAccount(selected);
    };
    load().catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [userId]);
  const returnToAdmin = () => guardAdminNavigation(() => { const url = new URL(window.location.href); url.searchParams.delete('roleScreen'); window.location.assign(url.toString()); });
  return <div className="standalone-role-screen">
    <header className="standalone-role-bar"><div><strong>{account ? labels[account.role] : 'Pantalla de rol'}</strong>{account && <span>{account.email} · Sesión de administrador</span>}</div><button className="wrm-secondary" onClick={returnToAdmin}>Volver a Wisby</button></header>
    {error ? <p className="wrm-message is-error" role="alert">{error}</p> : !account ? <p role="status">Cargando pantalla…</p> : <RoleViewContext.Provider value={userId}>{account.role === 'abogado_wisby' ? <LawyerWorkspace /> : <NotarioDashboard adminView currentUser="Administrador de Wisby" onNavigate={returnToAdmin} onLogout={returnToAdmin} />}</RoleViewContext.Provider>}
  </div>;
}
